import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogService } from '@progress/kendo-angular-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CedProductDetailsComponent } from '../ced-product-details/ced-product-details.component';
import { CedProductService } from '../ced-product.service';
import { CedProductModel } from '../models/ced-product.model';

@Component({
  selector: 'app-ced-product-list',
  templateUrl: './ced-product-list.component.html',
  styleUrls: ['./ced-product-list.component.scss']
})
export class CedProductListComponent implements OnInit, OnDestroy {
  private _subject$: Subject<boolean> = new Subject();
  products : CedProductModel[] = [];
  itemSelected :CedProductModel = null;

  constructor(
    private cedProductService : CedProductService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.getProducts();
  }

  getProducts(){
    this.cedProductService
    .getAllCedProducts()
    .pipe(takeUntil(this._subject$))
    .subscribe((data:any) => {
      this.products = data;
    });
  }

  dblClickEvent() { 
    if(this.itemSelected != null)
    this.cedProductService
          .getOneById(this.itemSelected.prdId)
          .pipe(takeUntil(this._subject$))
          .subscribe((data : any) => {
            this.itemSelected = data;
            this.openDialog(this.itemSelected);
            this.itemSelected = null;
          });     
  }

  
  openDialog(selectedItem){
    const dialogRef = this.dialogService.open({
      minWidth: "700px",
      content: CedProductDetailsComponent,
  });
  dialogRef.content.instance.selectedItem = selectedItem;
  dialogRef.result.subscribe((r) => {
    if (r == true) {
      this.getProducts();
    }
  });
 }

onCellClick($event) {
  this.itemSelected = $event.dataItem
}

ngOnDestroy(): void {
  this._subject$.next();
  this._subject$.complete();
}
}